module.exports = __webpack_public_path__ + "static/Logo SNL_ufficiale-5d3a7fe3a2fa4dc81173b685c0ac690b.png";